import React from "react";
import { PROCESS_STEPS } from "@/lib/site-data";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-28 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-20">
        <div className="md:col-span-5 md:sticky md:top-28 self-start reveal">
          <div className="flex items-center gap-4 mb-6">
            <span className="hairline w-10" />
            <span className="eyebrow">Our Process</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl leading-[1.05] tracking-tight text-[var(--text-primary)]">
            Four phases.
            <br />
            <em className="text-[var(--accent)]">One standard.</em>
          </h2>
          <p className="mt-8 text-[var(--text-secondary)] leading-relaxed max-w-md">
            Every project — whether a kitchen remodel or a ground-up custom
            home — follows a clear, honest path from conversation to
            completion.
          </p>
        </div>

        <div className="md:col-span-7 flex flex-col">
          {PROCESS_STEPS.map((s, i) => (
            <div
              key={s.n}
              className="reveal group relative flex gap-8 md:gap-12 py-10 border-b border-white/10 last:border-b-0"
              style={{ transitionDelay: `${i * 120}ms` }}
              data-testid={`process-step-${s.n}`}
            >
              <div className="flex flex-col items-center shrink-0">
                <span className="num-marker text-3xl md:text-4xl mb-4">
                  {s.n}
                </span>
                {i !== PROCESS_STEPS.length - 1 && (
                  <div className="step-line flex-1 group-hover:step-line-active transition-colors duration-500" />
                )}
              </div>
              <div className="pb-4">
                <h3 className="font-display text-3xl md:text-4xl text-[var(--text-primary)] group-hover:text-[var(--accent)] transition-colors duration-500 mb-3">
                  {s.label}
                </h3>
                <p className="text-[var(--text-secondary)] leading-relaxed max-w-xl">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
